import { render, staticRenderFns } from "./CompanySettingsTabs.vue?vue&type=template&id=5e7d376c&scoped=true"
import script from "./CompanySettingsTabs.vue?vue&type=script&lang=ts"
export * from "./CompanySettingsTabs.vue?vue&type=script&lang=ts"
import style0 from "./CompanySettingsTabs.vue?vue&type=style&index=0&id=5e7d376c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d376c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e7d376c')) {
      api.createRecord('5e7d376c', component.options)
    } else {
      api.reload('5e7d376c', component.options)
    }
    module.hot.accept("./CompanySettingsTabs.vue?vue&type=template&id=5e7d376c&scoped=true", function () {
      api.rerender('5e7d376c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/CompanySettingsTabs.vue"
export default component.exports